import {inboxHotkeys} from './modules/inbox'
import {documentViewerHotkeys} from './modules/document-viewer'
import {documentsListHotkeys} from './modules/documents'

export const appHotkeyModules = {
    documentViewer: {
        title: 'Document viewer',
        icon: '',
        hotkeys: documentViewerHotkeys
    },
    docs: {
        title: 'Documents list',
        icon: '',
        hotkeys: documentsListHotkeys
    },
    inbox: {
        title: 'Inbox',
        icon: '',
        hotkeys: inboxHotkeys
    }
}
